import { defineStore } from 'pinia'

export const useModalStore = defineStore('modal', {
  state: () => {
    return {
      registeredModals: [],
    }
  },
  actions: {
    registerModal (id, componentRef) {
      const existingRefIndex = this.registeredModals.findIndex(m => m.id === id);
      if (existingRefIndex >= 0) this.registeredModals.splice(existingRefIndex, 1);
      this.registeredModals.push({'id': id, 'ref': componentRef});
    },

    showModal(id) {
      const ref = this.getRef(id);
      if (!ref) return;
      ref.show();
    },

    hideModal(id) {
      const ref = this.getRef(id);
      if (!ref) return;
      ref.hide();
    },

    toggleModal(id) {
      const ref = this.getRef(id);
      if (!ref) return;
      ref.toggle();
    },

    getRef(id) {
      const registeredModal = this.registeredModals.find(m => m.id === id);
      if (!registeredModal) return null;

      return registeredModal.ref;
    }
  }
})
